import useJobDetails from "./useJobDetails";
import React from "react";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./JobDetails.scss";
import { job_title_limit_length } from "./constants";
import TextEditor from "../../../Common/Editor";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { SkillSearchInput } from "../../../../_uiComponents/Search/SkillSearchInput";
import LocationBasic from "../../../../_uiComponents/LocationBasic";

export const JobDetails = React.forwardRef((props, ref) => {
  const {
    publishMessage,
    formData,
    formInputsError,
    employmentType,
    experienceRequired,
    jobCurrency,
    editorActiveDescription,
    editorActiveRequirements,
    editorActiveBenefits,
    jobFunction,
    education,
    draftLoading,
    saveLoading,

    onKeywordsTagsAddition,
    onKeywordsTagsDelete,
    onDeleteClick,
    onInputChange,
    leftCharacters,
    onSubmitClick,
    onEditorStateChange,
    getHtmlData,
    onLocationChange,
    skillsTagsAdded,
  } = useJobDetails(props, ref);
  return (
    <div className="job-detail-wrapper mt-5 pl-lg-3 pr-lg-4">
      <Container>
        {/* Job title and Department details starts here */}
        {publishMessage && publishMessage.length > 0 ? (
          <span className="text-danger mt-1">{publishMessage}</span>
        ) : null}
        <Row>
          <Col md={8} className="job-detail pr-lg-5">
            <div className="top bg-grey-2 py-3 px-4">
              <h3 className="font-weight-medium">Title</h3>
            </div>
            <div className="py-3 px-4 bg-grey-5 form-group mb-0">
              <p className="font-weight-medium">
                <span className="text-danger">* </span>Job title
              </p>
              <input
                className="form-control bg-transparent"
                type="text"
                placeholder="Enter job title"
                onChange={(e) => onInputChange(e)}
                defaultValue={formData && formData?.title}
                name={"title"}
              ></input>
              {formInputsError.title && formInputsError.title.length > 0 ? (
                <span className="text-danger mt-2 line-height-14 d-inline-block">
                  {formInputsError.title}
                </span>
              ) : null}
              <p className="text-grey-4 mt-2 fs-smallest">
                {leftCharacters(job_title_limit_length, "title")} characters
                left. No special characters
              </p>
            </div>
          </Col>

          <Col md={4} className="pl-lg-5 px-5 px-md-0 mb-3 mb-md-0">
            <h3 className="mt-3 font-weight-medium">Tips</h3>
            <div className="job-title section pt-4">
              <p className="fs-smallest text-grey-4 mb-1">
                Use common job titles for searchability
              </p>
              <p className="fs-smallest text-grey-4 mb-1">
                Advertise for one job eg:’Designer’, not Designers’
              </p>
              <p className="fs-smallest text-grey-4">
                No general opportunities events
              </p>
            </div>
          </Col>
        </Row>

        {/* Job title and Department details ends here */}

        {/* Skills starts here */}
        <Row>
          <Col md={8} className="pr-lg-5">
            <div className="top bg-grey-2 py-3 px-4">
              <h3 className="font-weight-medium">Skills</h3>
            </div>
            <Row className="input-wrapper pt-3 pb-0 pb-md-5 px-4 bg-grey-5 mx-0">
              <Col md={10} className="px-0 pr-md-3 pr-lg-5">
                <div className="form-group">
                  <p className="font-weight-medium mb-1 fs-smallest">
                    <span className="text-danger">* </span>Skills
                  </p>
                  <div className="p-4 rounded-lg border mw-100">
                    <div className="d-flex flex-wrap align-items-center">
                      {Array.isArray(skillsTagsAdded) &&
                        skillsTagsAdded.map((tag, index) => (
                          <div
                            className="h4 bg-grey-3 py-1 rounded font-weight-normal text-dark px-2 mr-2 text-capitalize mb-3"
                            onClick={() => onKeywordsTagsDelete(tag)}
                            key={index}
                          >
                            {tag}
                            <FontAwesomeIcon icon={faXmark} className="ml-3" />
                          </div>
                        ))}
                    </div>
                    <SkillSearchInput
                      className="form-control mw-100"
                      placeholder="Search Skill..."
                      onSearchSelect={(item) => onKeywordsTagsAddition(item)}
                      clearSearch={true}
                      allowAdd={true}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
          <Col md={4} className="pl-lg-5 px-5 px-md-0 mb-3 mb-md-0">
            <div className="emp-details section pt-4">
              <p className="fs-smallest text-grey-4 mt-3 mt-md-5">
                Include as many details as possible to boost the job’s
                performance on job board
              </p>
            </div>
          </Col>
        </Row>

        {/* Location starts here */}
        <Row>
          <Col md={8} className="pr-lg-5">
            <div className="top bg-grey-2 py-3 px-4">
              <h3 className="font-weight-medium">Location</h3>
            </div>
            <div className="py-3 px-4 bg-grey-5">
              <LocationBasic
                onLocationChange={(name, value) =>
                  onLocationChange(name, value)
                }
                country={formData?.country}
                state={formData?.state}
                city={formData?.city}
              />
              <Col md={3} className="form-group mt-1 mt-md-3 px-0">
                <p className="fs-smallest mb-1">
                  <span className="text-danger">* </span>Zip code
                </p>
                <input
                  className="form-control bg-transparent"
                  type="text"
                  placeholder="Enter Zip code"
                  defaultValue={formData && formData?.zipcode}
                  onChange={(e) => onInputChange(e)}
                  name={"zipcode"}
                ></input>
                {formInputsError.zipcode &&
                formInputsError.zipcode.length > 0 ? (
                  <span className="text-danger mt-2 line-height-14 d-inline-block">
                    {formInputsError.zipcode}
                  </span>
                ) : null}
              </Col>
            </div>
          </Col>
          <Col md={4} className="pl-lg-5 px-5 px-md-0 mb-3 mb-md-0">
            <div className="location section pt-4">
              <p className="fs-smallest text-grey-4 mt-0 mt-md-5">
                Use a specific location to attract the most candidates
              </p>
            </div>
          </Col>
        </Row>
        {/* Location ends here */}

        {/* Employment details starts here */}
        <Row>
          <Col md={8} className="pr-lg-5">
            <div className="top bg-grey-2 py-3 px-4">
              <h3 className="font-weight-medium"> Employment details</h3>
            </div>
            <Row className="input-wrapper pt-3 pb-0 pb-md-5 px-4 bg-grey-5 mx-0">
              <Col md={6} className="pr-md-3 pr-lg-5 form-group p-0">
                <p className="font-weight-medium mb-1 fs-smallest">
                  <span className="text-danger">* </span>Employent type
                </p>
                <span className="select">
                  <select
                    className="form-control bg-transparent"
                    onChange={(e) => onInputChange(e)}
                    name={"employment_type"}
                    placeholder=" Select Employment Type"
                  >
                    <option
                      disabled={true}
                      value=""
                      selected={formData?.employment_type === undefined}
                    >
                      Select Employment Type
                    </option>
                    {Array.isArray(employmentType) &&
                      employmentType.map((item, index) => (
                        <option
                          key={index}
                          selected={formData?.employment_type === item.value}
                          value={item.value}
                        >
                          {item.key}
                        </option>
                      ))}
                  </select>
                  {formInputsError.employment_type &&
                  formInputsError.employment_type.length > 0 ? (
                    <span className="text-danger mt-2 line-height-14 d-inline-block">
                      {formInputsError.employment_type}
                    </span>
                  ) : null}
                </span>
              </Col>
              <Col md={6} className="pr-md-3 pr-lg-5 form-group p-0">
                <p className="font-weight-medium mb-1 fs-smallest">
                  <span className="text-danger">* </span>Experience
                </p>
                <span className="select">
                  <select
                    className="form-control bg-transparent"
                    onChange={(e) => onInputChange(e)}
                    name={"experience"}
                  >
                    <option
                      disabled={true}
                      value=""
                      selected={formData?.experience === undefined}
                    >
                      Select Experience
                    </option>
                    {Array.isArray(experienceRequired) &&
                      experienceRequired.map((item, index) => (
                        <option
                          key={index}
                          selected={formData?.experience === item.value}
                          value={item.value}
                        >
                          {item.key}
                        </option>
                      ))}
                  </select>
                  {formInputsError.experience &&
                  formInputsError.experience.length > 0 ? (
                    <span className="text-danger mt-2 line-height-14 d-inline-block">
                      {formInputsError.experience}
                    </span>
                  ) : null}
                </span>
              </Col>
              <Col md={6} className="pr-md-3 pr-lg-5 form-group p-0">
                <p className="font-weight-medium mb-1 fs-smallest">
                  <span className="text-danger">* </span>Education
                </p>
                <span className="select">
                  <select
                    className="form-control bg-transparent"
                    onChange={(e) => onInputChange(e)}
                    name={"education"}
                  >
                    <option
                      disabled={true}
                      value=""
                      selected={formData?.education === undefined}
                    >
                      <span className="placeholder"> Select Education</span>
                    </option>
                    {Array.isArray(education) &&
                      education.map((item, index) => (
                        <option
                          key={index}
                          selected={formData?.education === item.value}
                          value={item.value}
                        >
                          {item.key}
                        </option>
                      ))}
                  </select>
                  {formInputsError.education &&
                  formInputsError.education.length > 0 ? (
                    <span className="text-danger mt-2 line-height-14 d-inline-block">
                      {formInputsError.education}
                    </span>
                  ) : null}
                </span>
              </Col>
              <Col md={6} className="pr-md-3 pr-lg-5 form-group p-0">
                <p className="font-weight-medium fs-smallest mb-1">
                  <span className="text-danger">* </span>Job function
                </p>
                <span className="select">
                  <select
                    className="form-control bg-transparent"
                    onChange={(e) => onInputChange(e)}
                    name={"job_function"}
                  >
                    <option
                      disabled={true}
                      value=""
                      selected={formData?.job_function === undefined}
                    >
                      Select job function
                    </option>
                    {Array.isArray(jobFunction) &&
                      jobFunction.map((item, index) => (
                        <option
                          selected={formData?.job_function === item.value}
                          key={index}
                          value={item.value}
                        >
                          {item.key}
                        </option>
                      ))}
                  </select>
                  {formInputsError.job_function &&
                  formInputsError.job_function.length > 0 ? (
                    <span className="text-danger mt-2 line-height-14 d-inline-block">
                      {formInputsError.job_function}
                    </span>
                  ) : null}
                </span>
              </Col>
            </Row>
          </Col>
          <Col md={4} className="pl-lg-5 px-5 px-md-0 mb-3 mb-md-0">
            <div className="emp-details section pt-4">
              <p className="fs-smallest text-grey-4 mt-0 mt-md-5">
                Include as many details as possible to boost the job’s
                performance on job board
              </p>
            </div>
          </Col>
        </Row>

        {/* salary section starts from here */}
        <Row>
          <Col md={8} className="pr-lg-5">
            <div className="top bg-grey-2 py-3 px-4">
              <h3 className="font-weight-medium">Salary</h3>
            </div>
            <div className="salary-wrapper bg-grey-5 px-4">
              <p className="font-weight-medium fs-smallest pt-3">
                <span className="text-danger">* </span>Payment Type
              </p>
              <div className="d-flex">
                <div className="custom-control custom-radio mr-5">
                  <input
                    type="radio"
                    className="custom-control-input"
                    id="annually"
                    onChange={(e) => onInputChange(e)}
                    defaultChecked={
                      formData && formData?.payment_type === "annually"
                        ? "checked"
                        : null
                    }
                    name="payment_type"
                  />
                  <label
                    className="custom-control-label font-weight-medium"
                    htmlFor={"annually"}
                  >
                    Annually
                  </label>
                </div>
                <div className="custom-control custom-radio mr-5">
                  <input
                    type="radio"
                    className="custom-control-input"
                    id="monthly"
                    name="payment_type"
                    onChange={(e) => onInputChange(e)}
                    defaultChecked={
                      formData && formData?.payment_type === "monthly"
                        ? "checked"
                        : null
                    }
                  />
                  <label
                    className="custom-control-label ml-2 font-weight-medium"
                    htmlFor={"monthly"}
                  >
                    Monthly
                  </label>
                </div>
                <div className="custom-control custom-radio mr-5">
                  <input
                    type="radio"
                    className="custom-control-input"
                    id="hourly"
                    name="payment_type"
                    onChange={(e) => onInputChange(e)}
                    defaultChecked={
                      formData && formData?.payment_type === "hourly"
                        ? "checked"
                        : null
                    }
                  />
                  <label
                    className="custom-control-label ml-2 font-weight-medium"
                    htmlFor={"hourly"}
                  >
                    Hourly
                  </label>
                </div>
              </div>
              {formInputsError.payment_type &&
              formInputsError.payment_type.length > 0 ? (
                <span className="text-danger mt-2 line-height-14 d-inline-block">
                  {formInputsError.payment_type}
                </span>
              ) : null}
              <Row className="input-wrapper p-4">
                <Col md={6} lg={3} className="form-group p-0">
                  <p className="font-weight-medium mb-1 fs-smallest">
                    <span className="text-danger">* </span>From
                  </p>
                  <input
                    type="number"
                    placeholder="Eg: 200,000"
                    className="form-control bg-transparent"
                    onChange={(e) => onInputChange(e)}
                    name={"payment_from"}
                    defaultValue={formData && formData?.payment_from}
                  />
                  {formInputsError.payment_from &&
                  formInputsError.payment_from.length > 0 ? (
                    <span className="text-danger mt-2 line-height-14 d-inline-block">
                      {formInputsError.payment_from}
                    </span>
                  ) : null}
                </Col>
                <Col md={6} lg={4} className="form-group p-0 pl-md-3 pl-lg-5">
                  <p className="font-weight-medium mb-1 fs-smallest">
                    <span className="text-danger">* </span>To
                  </p>
                  <input
                    type="number"
                    placeholder="Eg: 400,000"
                    className="form-control bg-transparent"
                    onChange={(e) => onInputChange(e)}
                    name={"payment_to"}
                    defaultValue={formData && formData?.payment_to}
                  />
                  {formInputsError.payment_to &&
                  formInputsError.payment_to.length > 0 ? (
                    <span className="text-danger mt-2 line-height-14 d-inline-block">
                      {formInputsError.payment_to}
                    </span>
                  ) : null}
                </Col>
                <Col md={6} lg={5} className="form-group p-0 pl-lg-5">
                  <p className="font-weight-medium mb-1 fs-smallest">
                    <span className="text-danger">* </span>Currency
                  </p>
                  <span className="select">
                    <select
                      className="form-control bg-transparent"
                      onChange={(e) => onInputChange(e)}
                      name={"payment_currency"}
                    >
                      <option
                        disabled={true}
                        value=""
                        selected={formData?.payment_currency === undefined}
                      >
                        Select Currency
                      </option>
                      {Array.isArray(jobCurrency) &&
                        jobCurrency.map((item) => (
                          <option
                            key={item.key}
                            selected={formData?.payment_currency === item.value}
                            value={item.value}
                          >
                            {item.key}
                          </option>
                        ))}
                    </select>
                    {formInputsError.currency &&
                    formInputsError.currency.length > 0 ? (
                      <span className="text-danger mt-2 line-height-14 d-inline-block">
                        {formInputsError.currency}
                      </span>
                    ) : null}
                  </span>
                </Col>
              </Row>
            </div>
          </Col>
          <Col md={4} className="pl-lg-5 px-5 px-md-0 mb-3 mb-md-0">
            <div className="section pt-4">
              <p className="fs-smallest text-grey-4 mt-0 mt-md-5">
                Adding the salary here will improve performance on job board.
                You can also include the salary in job description
              </p>
            </div>
          </Col>
        </Row>
        {/* salary section ends here */}

        {/* Description starts from here */}
        <Row>
          <Col md={8} className="pr-lg-5">
            <div className="top bg-grey-2 py-3 px-4">
              <h3 className="font-weight-medium">Description</h3>
            </div>
            <div className="disc-container bg-grey-5 pb-2 pb-md-5 px-4">
              <h4 className="pt-3 pb-2 font-weight-medium">
                <span className="text-danger">* </span>About the role
              </h4>
              <div className="disc-wrapper mt-2 mb-4">
                <div className="py-3 px-4 bg-grey-5 mb-0">
                  <p className="font-weight-medium">Description</p>
                  <div
                    onClick={() => onEditorStateChange("Description")}
                    className="desc-wrapper"
                  >
                    {editorActiveDescription ? (
                      <TextEditor
                        htmlData={formData && formData?.role_description}
                        getHtmlData={(data) =>
                          getHtmlData(data, "role_description")
                        }
                      />
                    ) : (
                      <div className="placeholder p-2 text-grey-4 fs-smallest">
                        {formData?.role_description &&
                        formData?.role_description.length > 0 ? (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: formData?.role_description,
                            }}
                          ></div>
                        ) : (
                          "Enter the job description here, include key areas of responsibility and what the candidate might do on a typical day."
                        )}
                      </div>
                    )}
                  </div>
                </div>
                {formInputsError.role_description &&
                formInputsError.role_description.length > 0 ? (
                  <span className="text-danger line-height-14 d-inline-block pl-4">
                    {formInputsError.role_description}
                  </span>
                ) : null}
                <div className="py-3 px-4 bg-grey-5 mb-0">
                  <p className="font-weight-medium">Requirements</p>
                  <div onClick={() => onEditorStateChange("Requirements")}>
                    {editorActiveRequirements ? (
                      <TextEditor
                        htmlData={formData && formData?.role_requirements}
                        getHtmlData={(data) =>
                          getHtmlData(data, "role_requirements")
                        }
                      />
                    ) : (
                      <div className="placeholder p-2 text-grey-4 fs-smallest">
                        {formData?.role_requirements &&
                        formData?.role_requirements.length > 0 ? (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: formData?.role_requirements,
                            }}
                          ></div>
                        ) : (
                          "Enter the job requirements here, from soft skills to specific qualifications needed to perform the role."
                        )}
                      </div>
                    )}
                  </div>
                </div>
                {formInputsError.role_requirements &&
                formInputsError.role_requirements.length > 0 ? (
                  <span className="text-danger line-height-14 d-inline-block pl-4">
                    {formInputsError.role_requirements}
                  </span>
                ) : null}
                <div className="py-3 px-4 bg-grey-5 mb-0">
                  <p className="font-weight-medium">Benefits</p>
                  <div onClick={() => onEditorStateChange("Benefits")}>
                    {editorActiveBenefits ? (
                      <TextEditor
                        htmlData={formData && formData?.role_benefits}
                        getHtmlData={(data) =>
                          getHtmlData(data, "role_benefits")
                        }
                      />
                    ) : (
                      <div className="placeholder p-2 text-grey-4 fs-smallest">
                        {formData?.role_benefits &&
                        formData?.role_benefits.length > 0 ? (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: formData?.role_benefits,
                            }}
                          ></div>
                        ) : (
                          "Enter the benefits here, include not just salary details but the perks that make your company unique."
                        )}
                      </div>
                    )}
                  </div>
                </div>
                {formInputsError.role_benefits &&
                formInputsError.role_benefits.length > 0 ? (
                  <span className="text-danger line-height-14 d-inline-block pl-4 pb-4">
                    {formInputsError.role_benefits}
                  </span>
                ) : null}
              </div>
            </div>
          </Col>
          <Col md={4} className="pl-lg-5 px-5 px-md-0 mb-3 mb-md-0">
            <div className="description section pt-0 pt-md-4">
              <p className="fs-smallest text-grey-4 mt-3 mt-md-5">
                Include at least 700 characters (requirement)
              </p>
              <p className="fs-smallest text-grey-4">
                Format into sections and lists to improve readability
              </p>
              <p className="fs-smallest text-grey-4">
                Avoid targeting specific demographics eg: gender, nationality
                and age
              </p>
              <p className="fs-smallest text-grey-4">
                No need to add a link to apply (one is added automatically)
              </p>
            </div>
          </Col>
        </Row>

        {/* Description ends here */}
        <Row>
          <Col md={8} className="pr-lg-5">
            {formInputsError.formSubmitError &&
            formInputsError.formSubmitError.length > 0 ? (
              <span className="text-danger mt-1">
                {formInputsError.formSubmitError}
              </span>
            ) : null}
            <div className="bottom-part border-top d-flex justify-content-between align-items-center py-4 bg-grey-5 px-4">
              <div className="btn-wrapper">
                <button
                  className="btn btn-outline-light mr-4"
                  onClick={() => onSubmitClick("draft")}
                >
                  {draftLoading ? (
                    <Spinner animation="border" variant="primary" />
                  ) : (
                    "Save Draft"
                  )}
                </button>
                <button
                  className="btn btn-primary mr-4"
                  onClick={() => onSubmitClick("publish")}
                >
                  {saveLoading ? (
                    <Spinner animation="border" variant="white" />
                  ) : (
                    "Save and Publish"
                  )}
                </button>
              </div>
              {formData?.id && (
                <p
                  className="text-danger font-weight-medium cursor-pointer"
                  onClick={(e) => onDeleteClick()}
                >
                  Delete job
                </p>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
});
